<template>
  <div>
    <PaymentMethodsCardSelector @input="onPaymentMethodChange">
      <template #footer>
        <AlfaQuotaPayment
          :count="count"
          :method-id="method"
          :quota-type="quotaType"
          :new-card="!hasPaymentMethods || needNewCard"
          v-if="driver === paymentDrivers.ALFABANK"
          @success="onSuccess"
        />
        <StripeQuotaPayment
          :count="count"
          :method-id="method"
          :new-card="!hasPaymentMethods || needNewCard"
          :quota-type="quotaType"
          v-if="driver === paymentDrivers.STRIPE"
          @success="onSuccess"
        />
      </template>
    </PaymentMethodsCardSelector>
  </div>
</template>

<script>
import usePayment from '@/compositions/accounting/usePayment';
import { orderPlanOperations, orderTypes, paymentDrivers } from '@/enums';
import AlfaQuotaPayment from '@/components/Payment/Payment/Alfabank/AlfaQuotaPayment';
import StripeQuotaPayment from '@/components/Payment/Payment/Stripe/StripeQuotaPayment';
import useAccount from '@/compositions/accounting/useAccount';
import { computed, ref, toRefs } from '@vue/composition-api';
import usePaymentMethods from '@/compositions/accounting/usePaymentMethods';
import PaymentMethodsCardSelector from '@/components/Payment/Methods/PaymentMethodsCardSelector';

export default {
  name: 'QuotaPayment',
  components: {
    PaymentMethodsCardSelector,
    StripeQuotaPayment,
    AlfaQuotaPayment,
  },
  props: {
    newCard: {
      type: Boolean,
      default: false,
    },
    methodId: {
      type: Number,
      default: null,
    },
    quotaType: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit, root: { $router } }) {
    const {
      driver, setDriver,
    } = usePayment();
    const { methodId, quotaType } = toRefs(props);
    const method = ref(null);

    if (methodId.value) {
      method.value = methodId.value;
    }

    const needNewCard = ref(null);

    const { account } = useAccount();

    setDriver(account.value.driver);

    const { paymentMethods, fetchAll } = usePaymentMethods();
    fetchAll();

    function onPaymentMethodChange(val) {
      if (val !== 'new') {
        method.value = val;
        needNewCard.value = false;
        return;
      }
      method.value = null;
      needNewCard.value = true;
    }

    function onSuccess() {
      $router.replace({
        name: 'quota-order-success',
        params: {
          type: quotaType.value,
        },
      });
    }

    return {
      driver,
      paymentDrivers,
      hasPaymentMethods: computed(() => {
        return !!paymentMethods.value?.length > 0;
      }),
      needNewCard,
      onPaymentMethodChange,
      method,
      onSuccess,
    };
  },
};
</script>

<style scoped>

</style>

<i18n lang="yml" locale="ru">
agreePublic: 'Принимаю условия публичной '
offer: оферты
confirm: Подтвердить оплату

</i18n>
<i18n lang="yml" locale="en">
agreePublic: 'I accept the '
offer: terms and conditions
confirm: Confirm payment
</i18n>
